import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import { avatar, icon } from './ui';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/forum/components/LogInModal';
import SiteSidebar from './SiteSidebar';
export default class NovaIdPage extends Page {
  discord = null;
  discordLoading = false;
  discordNotice = '';
  discordError = '';
  oninit(vnode) {
    super.oninit(vnode);
    if (app.session.user) this.loadDiscord();
  }
  oncreate() {
    window.scrollTo(0, 0);
  }
  discordEndpoint() {
    return `${String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '')}/nova/discord`;
  }
  async loadDiscord() {
    this.discordLoading = true;
    try {
      this.discord = await app.request({
        method: 'GET',
        url: this.discordEndpoint()
      });
    } catch {
      this.discord = {
        linked: false,
        error: true
      };
    }
    this.discordLoading = false;
    m.redraw();
  }
  async linkDiscord() {
    this.discordLoading = true;
    try {
      const response = await app.request({
        method: 'POST',
        url: `${this.discordEndpoint()}/link`
      });
      if (response?.authorization_url) window.location.assign(response.authorization_url);
    } catch {
      this.discordLoading = false;
      m.redraw();
    }
  }
  async unlinkDiscord() {
    if (!window.confirm('Odłączyć konto Discord od NovaID?')) return;
    this.discordLoading = true;
    this.discordNotice = '';
    this.discordError = '';
    try {
      await app.request({
        method: 'DELETE',
        url: `${this.discordEndpoint()}/link`
      });
      this.discordNotice = 'Konto Discord zostało odłączone. Możesz je teraz połączyć ponownie.';
      await this.loadDiscord();
    } catch (error) {
      this.discordLoading = false;
      this.discordError = error?.response?.errors?.[0]?.detail || 'Nie udało się odłączyć Discorda. Spróbuj ponownie.';
      m.redraw();
    }
  }
  view() {
    const user = app.session.user;
    if (!user) return m("div", {
      className: "NtNovaIdPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("section", {
      className: "NtNovaIdGuest"
    }, icon('fas fa-id-card'), m("h1", null, "NovaID"), m("p", null, "Zaloguj si\u0119, aby otworzy\u0107 centrum po\u0142\u0105czonego konta NovaTruck & RP."), m(Button, {
      type: "button",
      className: "Button Button--primary",
      onclick: event => {
        event.preventDefault();
        app.modal.show(LogInModal, {});
      }
    }, "ZALOGUJ SI\u0118"))));
    const username = user.displayName?.() || user.username();
    const slug = user.slug?.() || user.username();
    return m("div", {
      className: "NtNovaIdPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("header", {
      className: "NtPageHeading"
    }, m("small", null, "JEDNO KONTO \u2022 CA\u0141Y EKOSYSTEM"), m("h1", null, "Centrum NovaID"), m("p", null, "Twoje konto forum jest po\u0142\u0105czone z kontem NovaTruck & RP.")), m("section", {
      className: "NtNovaIdCard"
    }, m("div", {
      className: "NtNovaIdIdentity"
    }, avatar(user), m("div", null, m("small", null, "Konto po\u0142\u0105czone"), m("strong", null, username), m("span", null, m("i", null), " NovaID aktywne"))), m("div", {
      className: "NtNovaIdActions"
    }, m(Link, {
      className: "Button Button--primary",
      href: `/u/${encodeURIComponent(slug)}/gracz`
    }, icon('fas fa-gamepad'), " PROFIL GRACZA"), m(Link, {
      className: "Button",
      href: app.route('settings')
    }, icon('fas fa-cog'), " USTAWIENIA FORUM"))), m("section", {
      className: "NtDiscordConnect"
    }, m("span", null, icon('fab fa-discord')), m("div", null, m("small", null, "INTEGRACJA NOVA ID"), m("strong", null, this.discord?.linked ? `Połączono: ${this.discord.discord?.discord_username || 'Discord'}` : 'Połącz konto Discord'), m("p", null, this.discord?.linked ? 'Nick, rola zweryfikowanego gracza i role projektu są synchronizowane automatycznie.' : 'Połącz konto, aby korzystać z NovaChat, komend i automatycznych rang.')), this.discord?.linked ? m(Button, {
      type: "button",
      className: "Button",
      loading: this.discordLoading,
      onclick: () => this.unlinkDiscord()
    }, "OD\u0141\u0104CZ") : m(Button, {
      type: "button",
      className: "Button Button--primary",
      loading: this.discordLoading,
      onclick: () => this.linkDiscord()
    }, icon('fab fa-discord'), " PO\u0141\u0104CZ DISCORD")), this.discordNotice ? m("div", {
      className: "NtNovaIdNotice"
    }, this.discordNotice) : null, this.discordError ? m("div", {
      className: "NtNovaIdError"
    }, this.discordError) : null, m("div", {
      className: "NtNovaIdInfo"
    }, m("section", null, icon('fas fa-link'), m("strong", null, "Wsp\xF3lna to\u017Csamo\u015B\u0107"), m("p", null, "Forum, MTA i Discord korzystaj\u0105 z jednego powi\u0105zania NovaID.")), m("section", null, icon('fas fa-shield-alt'), m("strong", null, "Bezpieczne powi\u0105zanie"), m("p", null, "Istniej\u0105ce konta zachowuj\u0105 posty, grupy i dane postaci.")), m("section", null, icon('fas fa-comments'), m("strong", null, "NovaChat"), m("p", null, "Jeden wsp\xF3lny czat dost\u0119pny na forum, Discordzie i serwerze MTA."))))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/NovaIdPage', NovaIdPage);